import { dom, library, config } from '@fortawesome/fontawesome-svg-core';

config.autoReplaceSvg = true;
config.observeMutations = true;
// config.searchPseudoElements = true; 

import { faPlay, faNewspaper, faCalendarAlt, faCog } from '@fortawesome/pro-solid-svg-icons'
import { faSearch, faTimes, faAngleRight, faAngleLeft, faAngleUp, faAngleDown, faFilePdf, faExternalLink, faLink, faArrowUp, faArrowDown, faUser, faSignOut } from '@fortawesome/pro-regular-svg-icons'
import { faTwitter, faFacebookF, faFacebook, faLinkedin, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons'

library.add(
    faSearch,
    faTimes,
    faAngleRight, 
    faAngleLeft,
    faAngleUp,
    faAngleDown,
    faTwitter, 
    faFacebook, 
    faFacebookF, 
    faLinkedin, 
    faLinkedinIn, 
    faInstagram, 
    faExternalLink, 
    faLink,
    faFilePdf,
    faPlay,
    faNewspaper,
    faCalendarAlt,
    faCog,
    faArrowUp,
    faArrowDown,
    faUser,
    faSignOut,
);

dom.watch();
